<div class="wrapper flex">
  <app-sidebar></app-sidebar>
  <div class="content grow1">
    <router-outlet></router-outlet>
  </div>
</div>
